<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h3>본인인증하기</h3>
        </div>
        <div class="section-body">
          <ul class="notice-text-list">
            <li class="notice-text">
              가입신청을 완료하신 후 아래의 방법 중 한가지로 본인인증을 하시기
              바랍니다. (인증 진행 후 인증하기 버튼 클릭)
            </li>
          </ul>

          <dl class="field-group">
            <dt class="field-label">
              인증수단선택
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <div
                        id="radio-button-container-id-verification-type-card"
                        class="input-container input-horizontal"
                >
                  <input
                          id="select-verification-type-card"
                          v-model="$store.state.step1.autnMthdDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="C"
                          class="input-radio"
                          title="본인인증수단 선택"
                  />
                  <label for="select-verification-type-card" class="input-label"
                  >신용카드인증</label
                  >
                </div>
                <div
                        id="radio-button-container-id-verification-type-auth"
                        class="input-container input-horizontal"
                        v-if="!($store.state.isMobile)"
                >
                  <input
                          id="select-verification-type-auth"
                          v-model="$store.state.step1.autnMthdDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="A"
                          class="input-radio"
                          title="본인인증수단 선택 범용공동인증 창 열림"
                  />
                  <label for="select-verification-type-auth" class="input-label"
                  >범용공동인증</label
                  >
                </div>
                <div
                        v-if="
                    openMarketInfo.registrationTypeCode === 'chg' ||
                      openMarketInfo.registrationTypeCode === 'renew'
                  "
                        id="radio-button-container-id-verification-type-mobile"
                        class="input-container input-horizontal"
                >
                  <!-- <div id="radio-button-container-id-verification-type-mobile" class="input-container input-horizontal"> -->
                  <input
                          id="select-verification-type-mobile"
                          v-model="$store.state.step1.autnMthdDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="M"
                          class="input-radio"
                          title="본인인증수단 선택"
                  />
                  <label
                          for="select-verification-type-mobile"
                          class="input-label"
                  >휴대폰인증</label
                  >
                </div>
              </div>

              <div class="field-control-sub">
                <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            id="id-verification-input-name"
                            class="input-sub-text w120 mw100"
                    >이름</label
                    >
                  </dt>
                  <dd>
                    <input
                            for="id-verification-input-name"
                            type="text"
                            @input="onlyText"
                            name="lgdBuyer"
                            placeholder="이름"
                            v-model="retrieveData.lgdBuyer"
                            class="input-text input-width-medium input-font"
                            title="성명입력"
                    />
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            id="id-verification-input-birthdate"
                            class="input-sub-text w120 mw100"
                    >생년월일</label
                    >
                  </dt>
                  <dd>
                    <input
                            for="id-verification-input-birthdate"
                            type="text"
                            autocomplete="off"
                            placeholder="6자리입력"
                            v-model="retrieveData.lgdPrivateno"
                            @input="onlyNumber"
                            name="lgdPrivateno"
                            maxlength="6"
                            class="input-text input-width-medium input-font"
                            title="생년월일 6자리 입력"
                    />
                  </dd>
                </dl>
              </div>
              <div
                      v-if="$store.state.step1.autnMthdDivsCd === 'C'"
                      class="field-control-sub"
              >
                <dl class="field-control-sub sub-form">
                  <dt>
                    <label
                            for="verification-card-number"
                            class="input-sub-text w120 mw100"
                    >카드번호</label
                    >
                  </dt>
                  <dd>
                    <input
                            id="verification-card-number"
                            type="text"
                            @input="onlyNumber"
                            name="lgdPan"
                            ref="ref_lgdPan"
                            maxlength="16"
                            autocomplete="off"
                            placeholder="'-'없이 입력하세요"
                            v-model="retrieveData.lgdPan"
                            class="input-text input-width-medium input-font"
                            title="본인인증 가능한 신용카드 번호 입력"
                    />
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form">
                  <dt>
                    <label class="input-sub-text w120 mw100"
                    >유효기간(년/월)</label
                    >
                  </dt>
                  <dd class="m-input-half">
                    <dl class="m-input-half-sub">
                      <dt>
                        <label
                                for="verification-card-expired-year"
                                class="input-sub-text blind"
                        >년</label
                        >
                      </dt>
                      <dd>
                        <select
                                id="verification-card-expired-year"
                                v-model="retrieveData.lgdExpyear"
                                class="input-width-xsmall mw100"
                                title="본인인증 가능한 신용카드의 유효기간 년 선택"
                        >
                          <option
                                  v-for="year in yearList"
                                  :value="year"
                                  :key="year"
                          >{{ year }}</option
                          >
                        </select>
                      </dd>
                    </dl>
                    <span class="field-group-space">/</span>
                    <dl class="m-input-half-sub">
                      <dt>
                        <label
                                for="verification-card-expired-month"
                                class="input-sub-text blind"
                                title="본인인증 가능한 신용카드의 유효기간 월 선택"
                        >월</label
                        >
                      </dt>
                      <dd>
                        <select
                                id="verification-card-expired-month"
                                v-model="retrieveData.lgdExpmon"
                                class="input-width-xsmall mw100"
                        >
                          <option
                                  v-for="month in monthList"
                                  :value="month"
                                  :key="month"
                          >{{ month }}</option
                          >
                        </select>
                      </dd>
                    </dl>
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form m-input-col">
                  <dt>
                    <label
                            for="verification-card-pinnumber"
                            class="input-sub-text w120 mw100"
                    >비밀번호</label
                    >
                  </dt>
                  <dd>
                    <input
                            id="verification-card-pinnumber"
                            type="password"
                            placeholder=""
                            v-model="retrieveData.lgdPin"
                            autocomplete="new-password"
                            @input="onlyNumber"
                            name="lgdPin"
                            maxlength="2"
                            class="input-text input-width-xsmall input-font mw20"
                            title="본인인증 가능한 신용카드 비밀번호 앞 2자리 숫자 입력"
                    />
                    <span class="input-sub-text">** (앞 2자리)</span>
                    <span class="field-group-space"></span>
                    <button
                            type="submit"
                            class="m-right mw40"
                            @click="cardVerification"
                    >
                      인증하기
                    </button>
                  </dd>
                </dl>
              </div>

              <div
                      v-if="$store.state.step1.autnMthdDivsCd === 'A'"
                      class="field-control-sub"
              >
                <dl>
                  <dt class="blind">범용공동인증하기</dt>
                  <dd>
                    <button
                            type="button"
                            title="공인인증모듈 호출"
                            class="m-right mw100"
                            @click="authVerification"
                    >
                      인증하기
                    </button>
                  </dd>
                </dl>
              </div>

              <div
                      v-if="$store.state.step1.autnMthdDivsCd === 'M'"
                      class="field-control-sub"
              >
                <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            for="verification-phonenumber"
                            class="input-sub-text w120 mw100"
                    >휴대폰번호</label
                    >
                  </dt>
                  <dd>
                    <input
                            id="verification-phonenumber"
                            type="text"
                            @input="onlyNumber"
                            name="phoneNo"
                            autocomplete="off"
                            v-model="retrieveData.phoneNo"
                            placeholder="'-' 없이 입력하세요"
                            class="input-text input-width-medium input-font"
                            title="본인인증할 휴대폰 번호 입력"
                            maxlength="11"
                    /><button type="button" @click="getVerificationNumber">
                    인증번호 발송
                  </button>
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form m-input-half ml0">
                  <dt>
                    <label
                            for="verification-receieved-code-number"
                            class="input-sub-text w120 mw100"
                    >인증번호입력</label
                    >
                  </dt>
                  <dd>
                    <input
                            id="verification-receieved-code-number"
                            type="text"
                            @input="onlyNumber"
                            name="smsval"
                            autocomplete="off"
                            v-model="retrieveData.smsval"
                            maxlength="6"
                            class="input-text input-width-medium input-font "
                    /><button type="submit" class="" @click="hpVerification">
                    인증하기
                  </button>
                  </dd>
                </dl>
              </div>

              <div class="field-control-sub">
                <ul class="notice-text-list">
                  <li class="notice-text">
                    전자 서명법에 따라 용도제한 공인인증서(은행용 공인인증서
                    등)로는 이용이 불가함을 양해해주시기 바랍니다.
                  </li>
                  <li class="notice-text">
                    <em class="primary-text"
                    >본인인증 후 해당서류를 FAX접수해 주시기 바랍니다.</em
                    >
                    (신분증 사본 / 청소년일 경우 부모님의 신분증 및
                    가족관계증명서 또는 주민등록 등본)
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <!-- 임시 -->
      <!-- <div class="step-bottom-area input-wrap">
        <button class="primary-button mw100 pc-float-right" @click="go">
          다음(임시)
        </button>
      </div> -->
      <!-- 임시 -->
    </div>
    <v-dialog />
  </div>
</template>

<script>
  import { createAppFormEndding } from '@/api/captureService'
  import {
    commCode,
    xPayCardAuthcheck,
    smsAuthSend,
    smsAuthCheck
  } from '@/api/step3/identificationVerfication'
  import { callNormalPopup, retrieveDateList } from '@/api/common'
  export default {
    name: 'IdentityVerificationSection_samsung',
    data() {
      return {
        registration: {
          dcntKdNm: '', // 할인유형명
          pymnBday: '', // 납부자생년월일
          appfNo: '', //신청서번호
          crypAppfNo: '', // 암호화 신청서번호
          rqstPgrsStusNm: '', //신청진행상태명
          onetKdCd: '', //가입유형코드
          onetKdNm: '', //가입유형명
          ppCd: '', //요금제코드
          sppsProdCdCntn: '', //부가서비스상품코드내용
          dataPpCd: '', //데이터요금제코드
          custKdCd: '', //고객유형코드
          aplcNm: '', //신청자명
          aplcDerno: '', //신청자주민등록번호--------------->최초
          aplcDernoMask: '', //신청자주민등록번호--------------->마스킹
          aplcTlno: '', //신청자전화번호
          aplcEmalAddr: '', //신청자이메일주소
          bltxRcepMthdCd: '', //청구서수령방법코드
          billDivsCd: '', //청구구분코드
          crplZpcd: '', //청구지우편번호
          crplAddr: '', //청구지주소
          crplDadr: '', //청구지상세주소
          pymnDivsCd: '', //납부자구분코드 TODO 본인:1 / 타인:2
          pymnNm: '', //납부자명 TODO 청소년이면 대리인
          pymnDerno: '', //납부자주민등록번호--------------->최초 TODO 청소년이면 대리인
          pymnEmalAddr: '', //납부자이메일주소 TODO 청소년이면 대리인
          paymMthdDivsCd: '', //납부방법구분코드
          bankNm: '', //은행명
          CdcoNm: '', //카드사명
          onetBankCd: '', //온라인가입은행코드
          onetCdcoCd: '', //온라인가입카드사코드
          acctCardNo: '', //계좌카드번호--------------->화면보기
          acctCardNoMask: '', //계좌카드번호마스킹
          ccrdValdTermEndYymm: '', //신용카드유효기간종료년월
          wdrwAgrYn: '', //출금동의여부
          mnpSoacTrgtCd: '', //번호이동정산대상코드
          mnpSoacNo: '', //번호이동정산번호
          noRnftEnprCd: '', //번호이동전사업자코드
          trmSrno: '', //단말시리얼번호
          dvicMdlCd: '', //단말기모델코드
          dvicMdlNm: '', //단말기모델명
          dvicColrCd: '', //단말기색상코드
          hphnColrNm: '', //휴대폰색상명
          chgHopTlno: '', //변경희망전화번호
          crgrBuyYn: 'N', //충전기구매여부
          ppNm: '', //요금제명
          dataPpNm: '', //데이터요금제명
          sppsProdNmCntn: '', //부가서비스상품명내용
          adltCntsIsolRqstYn: '', //성인컨텐츠차단신청여부
          agntEntrRstnYn: '', //대리인가입제한여부
          lawcAgntNm: '', //법정대리인명
          decLawcAgntCrypRrno: '', //------->입력
          lawcAgntCrypRrnoMask: '', //법정대리인암호화주민등록번호마스킹
          lawcAgntTlno: '', //법정대리인전화번호
          lawcAgntZpcd: '', //법정대리인우편번호
          lawcAgntAddr: '', //법정대리인주소
          lawcAgntDadr: '', //법정대리인상세주소
          isttTermMmct: '24', //할부기간개월수 halbuMonth
          tinsAmt: '0', //총할부금액 halbuPrice
          adseRqstDivsCd: '', //선결제신청구분코드
          lssInsrDivsNm: '', //분실보험구분명
          dcntDivsCd: '', //할인구분코드
          dcntTermMmct: '', //할인기간개월수 =agreedMonthM2M / discMonth
          dcntKdCd: '', //할인유형코드
          agmtTermMmct: '0', //약정기간개월수
          onsaAplyPlnNm: '', //온라인가입지원적용플랜명
          iphnUseAgrYn: '', //아이폰사용동의여부
          nwIsolYn: '', //네트워크차단여부
          entrAppfDvrMthdCd: '', //가입신청서교부방법코드
          entrAppfDvrMthdNm: '', //가입신청서교부방법명
          dlvRcipNm: '', //배송수령자명
          dlplZpcd: '', //배송지우편번호
          dlplBadr: '', //배송지기본주소
          dlplDadr: '', //배송지상세주소
          dlplTlno: '', //배송지전화번호
          dlvCtplNm: '', //배송연락처명
          custInfoGthrAgrYn: '', //고객정보수집동의여부
          pnifPuseTrstAgrYn: '', //개인정보활용위탁동의여부
          locFndnInfoOfrSvcAgrYn: '', //위치기반정보제공서비스동의여부
          autnMthdDivsCd: '', //인증방법구분코드
          prmsLinePcnt: '', //허용회선개수
          addReqMttrCntn: '', //추가요청사항내용
          dutyAgmtSuptAmt: '0', //의무약정지원금액 =dutyAgmtSuptAmt
          hphnInitStlmAmt: '', //휴대폰초기결제금액
          lssInsrCnslAgrYn: '', //분실보험상담동의여부
          dutyAgmtAgrYn: 'N', //의무약정동의여부 agreedAgreeYn
          rqstSppsCdCntn: '', //신청부가서비스코드내용
          dealAgmtAmt: '0', //대리점약정금액
          custBday: '', //고객생년월일
          lawcAgntAgrYn: '', //법정대리인동의여부
          smatAppUseYn: '', //스마트APP사용여부
          bukeAppUseYn: '', //사업지키미APP사용여부f
          rotrRqstYn: '', //라우터신청여부 formRoutrYn
          rotrAgmtMmct: '0', //라우터약정개월수
          rotrAgmtAmt: '0', //라우터약정금액
          browDivsCd: '', //브라우저구분코드
          rqstSppsNmCntn: '', //신청부가서비스명내용
          entrRqstFomNo: '', //가입신청양식번호
          opmkNo: '', //오픈마켓번호
          onlnAppfNo: '', //온라인신청서번호
          sbgnPosCd: '', //개통POS코드
          sbgnDealCd: '', //개통대리점코드
          dealNm: '', //대리점명
          opmkNm: '', //오픈마켓명
          svcDivsCd: '', //서비스구분코드
          shpnEntrRqstYn: '' //중고폰가입신청여부
        },
        retrieveData: {
          lgdBuyer: '', // 고객이름
          lgdPrivateno: '', // 생년월일
          lgdPan: '', // 카드번호
          lgdExpyear: '', // 년도
          lgdExpmon: '', // 월
          lgdPin: '', // 카드 비밀번호
          dealCd: '', // 대리점 번호
          onetMblAppfNo: '', // 신청서 번호
          phoneNo: '', // 휴대폰 번호
          smsval: '', // 인증번호 결과
          miltaryAgentYn: '',
        },
        verificationCheck: false,
        bank: '',
        card: '',
        accountNo: '',
        cardNo: '',
        yearList: [],
        monthList: [],
        openMarketInfo: {}
      }
    },

    components: {},
    created() {
      this.initPage()
      // 대리점 코드, 신청서 번호
      this.retrieveData.dealCd = this.openMarketInfo.dealCd
      this.retrieveData.onetMblAppfNo = this.registration.appfNo
      // FIXME 개발용 소스로 API 연결이 되면 삭제 할 소스
      // if (!this.retrieveData.dealCd) {
      //   this.retrieveData.dealCd = '314365'
      // }
      // if (!this.retrieveData.onetMblAppfNo) {
      //   this.retrieveData.onetMblAppfNo = '1120031200008731'
      // }

      // 년도 조회
      this.yearList = retrieveDateList("year")
      this.retrieveData.lgdExpyear = this.yearList[0]
      // 월 조회
      this.monthList = retrieveDateList("month")
      this.retrieveData.lgdExpmon = this.monthList[0]
    },
    mounted() {
      this.$store.state.processIndicator.step1 = false
      this.$store.state.processIndicator.step2 = false
      this.$store.state.processIndicator.step3 = true
      this.$store.state.processIndicator.step4 = false
    },
    methods: {
      /**
       * Function    : onlyNumber
       * Description : input값 숫자 체크
       **/
      onlyNumber(e) {
        this.retrieveData[e.target.name] = e.target.value.replace(/[^0-9]/gi, '')
      },

      /**
       * Function    : onlyText
       * Description : input값 텍스트 체크
       **/
      onlyText(e) {
        this.retrieveData[e.target.name] = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      },

      /**
       * Function    : initPage
       * Description : 본인인증 초기값 세팅
       **/
      initPage() {
        this.registration = this.$route.params.registration
        this.openMarketInfo = this.$route.params.openMarketInfo
      },

      /**
       * Function    : cardVerification
       * Description : 신용카드 인증
       **/
      cardVerification() {
        let title = '신용카드인증'
        Object.assign(this.retrieveData, {miltaryAgentYn: this.openMarketInfo.miltaryAgentYn})
        if(this.retrieveData.lgdPan.length<13) {
          this.openAlertTemp(title, "카드번호 자리수를 확인해주세요.", this.$refs.ref_lgdPan)
          return
        }
        xPayCardAuthcheck(this.retrieveData).then(res => {
          let resultCd = res.data.dsRsltInfo.rsltCd
          let resultMsg = res.data.dsRsltInfo.rsltMsg
          if (resultCd === 'SUCCESS') {
            this.verificationCheck = true
            this.openAlert(title, resultMsg)
          } else {
            this.openAlertTemp(title, resultMsg)
          }
        })
      },

      /**
       * Function    : hpVerification
       * Description : 휴대폰 인증하기
       **/
      hpVerification() {
        let title = '휴대폰인증'
        smsAuthCheck(this.retrieveData).then(res => {
          let resultCd = res.data.dsRsltInfo.rsltCd
          let resultMsg = res.data.dsRsltInfo.rsltMsg
          if (resultCd === 'SUCCESS') {
            this.verificationCheck = true
            this.openAlert(title, resultMsg)
          } else {
            this.openAlertTemp(title, resultMsg)
          }
        })
      },

      /**
       * Function    : getVerificationNumber
       * Description : 휴대폰 번호 인증번호 발송
       **/
      getVerificationNumber() {
        let hpRegx = /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/
        let title = '휴대폰인증'
        if (hpRegx.test(this.retrieveData.phoneNo)) {
          smsAuthSend(this.retrieveData).then(res => {
            let resultCd = res.data.dsRes.msgCd
            let resultMsg = res.data.dsRes.msg
            if (resultCd === 'SUCCESS') {
              this.openAlertTemp(title, resultMsg)
              this.retrieveData.pAuthKey = res.dsRes.testReturn
            } else {
              this.openAlert(title, resultMsg)
            }
          })
        } else {
          this.openAlertTemp(title, '휴대폰 번호를 확인해 주세요.')
        }
      },

      /**
       * Function    : authVerification
       * Description : 범용 공인인증
       **/
      authVerification() {
        let title = '공동인증'
        let reqData = {
          custNm: this.retrieveData.lgdBuyer,
          custPersId: this.retrieveData.lgdPrivateno,
          onetMblAppfNo: this.registration.appfNo,
          pymnDivsCd: this.registration.pymnDivsCd
        }
        callNormalPopup(reqData).then(res => {
          // 공인인증 팝업이 열리고, 리턴데이터를 받는다.
          let response = JSON.parse(res)
          if (response.rsltCd === 'SUCCESS') {
            // this.$router.push({
            //   name: 'RegistrationStep4'
            // })
            this.verificationCheck = true
            this.openAlert(title, response.rsltMsg)
          } else {
            this.openAlertTemp(title, response.rsltMsg)
          }
        })
      },

      /**
       * Function    : openAlert
       * Description : 최종저장까지 하는 alert 호출 함수
       **/
      openAlert(title, message) {
        this.$modal.show('dialog', {
          title: title,
          text: message,
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
                if (this.verificationCheck) {
                  this.save()
                }
              }
            }
          ]
        })
      },

      /**
       * Function    : openAlertTemp
       * Description : 기본 alert 호출 함수
       **/
      openAlertTemp(title, message, ref) {
        this.$modal.show('dialog', {
          text: message,
          title: title,
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                if (ref) {
                  ref.focus()
                }
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },

      /**
       * Function    : save
       * Description : 최종 저장 함수
       **/
      save() {
        this.$modal.hide('dialog')
        Object.assign(this.registration, {autnMthdDivsCd:this.$store.state.step1.autnMthdDivsCd})
        createAppFormEndding(this.registration).then(res => {
          let dsRes = res.data.dsRes
          if (dsRes.msgCd === 'SUCCESS') {
            this.$modal.show('dialog', {
              title: '최종저장 성공',
              text: dsRes.msg,
              buttons: [
                {
                  title: '확인',
                  class: 'primary-button',
                  handler: () => {
                    this.$modal.hide('dialog')
                    this.$router.push({
                      name: 'RegistrationStep4_samsung'
                    })
                  }
                }
              ]
            })
          } else {
            this.openAlertTemp('최종저장 실패', dsRes.msg)
          }
        })
      },

      // go() {
      //   this.save()
      // }
    }
  }
</script>

<style scoped></style>
